import React, {useEffect, useState} from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import {Form, Input, Button, Row, Col, Select, Checkbox} from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import {toast} from 'react-toastify'

const EmailTemplateModal = ({
  visible,
  onClose,
  templateId,
  onSuccess,
  form,
}) => {
  const {getFieldDecorator, setFieldsValue, validateFields, resetFields} = form
  const [emailBody, setEmailBody] = useState('')
  const [showRecurring, setShowRecurring] = useState(false)
  const [fileList, setFileList] = useState([])
  const loggedInUserID = JSON.parse(localStorage.getItem('loggedInUserID'))
  const data = [
    {name: 'Policy', id: 'policy'},
    {name: 'Quotation', id: 'quotation'},
    {name: 'ClaimPop', id: 'ClaimPop'},
    {name: 'Payment Receipt', id: 'PaymentReceipt'},
    {name: 'Claim', id: 'Claims'},
  ]
  const DurationData = [
    {name: 'Day', id: 'day'},
    {name: 'Month', id: 'month'},
    {name: 'Year', id: 'year'},
  ]

  useEffect(() => {
    if (templateId) {
      fetchTemplateDetails(templateId)
    } else {
      form.resetFields()
      setEmailBody('')
    }
  }, [templateId, visible])

  useEffect(() => {
    if (visible) fetchFiles()
  }, [visible])

  const fetchTemplateDetails = async id => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_EMAIL + `/Email/get-template/${id}`,
        'GET',
      )
      if (response.success) {
        setFieldsValue({
          name: response?.data?.name,
          subject: response?.data?.subject,
          body: encodeHTML(response?.data?.body),
          sendInstantEmail:
            response?.data?.sendInstantEmail === true ? 'true' : 'false',
          recurringPeriod: response?.data?.recurringPeriod || undefined,
          Attachments: response?.data?.attachments || [],
        })
        setShowRecurring(response?.data?.sendInstantEmail === false)
        console.log('body being fetched', response?.data?.body)
        setEmailBody(encodeHTML(response?.data?.body) || '')
      }
      setTimeout(() => {
        setFieldsValue({
          recurringEmail: response?.data?.recurringEmail || false,
          duration: response?.data?.duration || '',
        })
      }, [500])
    } catch (error) {
      console.error('Error fetching template:', error)
    }
  }

  const fetchFiles = async () => {
    try {
      setFileList(data || [])
    } catch (err) {
      console.error('File fetch error:', err)
    }
  }

  const cleanExtraPTags = html => {
    return html
      .replace(/<p><(html|head|body|table|tr|td|style|script)[^>]*>/g, '<$1>')
      .replace(/<\/(html|head|body|table|tr|td|style|script)><\/p>/g, '</$1>')
      .replace(/<p>/g, '') 
      .replace(/<\/p>/g, '') 
  }

  const extractVariables = body => {
    const regex = /\{{(.*?)\}}/g
    let matches = []
    let match
    while ((match = regex.exec(body)) !== null) {
      matches.push(match[1])
    }
    return matches
  }

  const handleSubmit = e => {
    e.preventDefault()

    validateFields(async (err, values) => {
      if (err) return
      const cleanedBody = cleanExtraPTags(emailBody)

      const variables = extractVariables(cleanedBody)

      const email_body = decodeHTML(cleanedBody)
      const payload = {
        name: values?.name,
        subject: values?.subject,
        body: email_body,
        hasAttachment: values?.Attachments?.length > 0 ? true : false,
        variables,
        sendInstantEmail: values?.sendInstantEmail === 'true' ? true : false,
        duration: values?.duration || '',
        recurringEmail: values?.recurringEmail || false,
        Attachments: values?.Attachments || [],
        insurerId: loggedInUserID,
      }
      const url = templateId
        ? process.env.REACT_APP_BASE_URL_EMAIL +
          `/Email/update-template/${templateId}`
        : process.env.REACT_APP_BASE_URL_EMAIL + `/Email/create-template`

      try {
        const response = await apiRequest(url, 'POST', payload)
        if (response?.success) {
          toast.success(
            templateId
              ? 'Template updated successfully'
              : 'Template added successfully',
          )
          onSuccess && onSuccess()
        } else {
          toast.error(response?.error || 'Error saving template')
        }
      } catch (error) {
        toast.error('Something went wrong. Please try again.')
      }
    })
  }

  const quillModules = {
    toolbar: [
      [{header: [1, 2, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      [{list: 'ordered'}, {list: 'bullet'}],
      [{script: 'sub'}, {script: 'super'}],
      [{indent: '-1'}, {indent: '+1'}],
      [{align: []}],
      ['code-block'],
      ['link', 'image'],
      ['clean'],
    ],
  }

  const decodeHTML = html => {
    const txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }

  const encodeHTML = str => {
    const txt = document.createElement('textarea');
    txt.textContent = str;
    return txt.innerHTML;
  };

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form
          layout="vertical"
          style={{height: '800px'}}
          onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Template Name">
                {getFieldDecorator('name', {
                  rules: [
                    {required: true, message: 'Please enter the template name'},
                  ],
                })(<Input placeholder="Enter Template Name" />)}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Subject">
                {getFieldDecorator('subject', {
                  rules: [
                    {required: true, message: 'Please enter the subject'},
                  ],
                })(<Input placeholder="Enter Subject" />)}
              </Form.Item>
            </Col>
            <Col md={24}>
              <Form.Item label="Attach Files">
                {getFieldDecorator('Attachments')(
                  <Select mode="multiple" placeholder="Select files to attach">
                    {fileList.map(file => (
                      <Select.Option key={file.id} value={file.id}>
                        {file.name}
                      </Select.Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Email Frequency">
                {getFieldDecorator('sendInstantEmail', {
                  initialValue: 'Select Email Frequency',
                  rules: [
                    {required: true, message: 'Please select a frequency type'},
                  ],
                })(
                  <Select onChange={val => setShowRecurring(val === 'false')}>
                    <Select.Option value="true">Send Now</Select.Option>
                    <Select.Option value="false">Send Later</Select.Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            {showRecurring && (
              <>
                <Col md={12}>
                  <Form.Item label="Repeat Every">
                    {getFieldDecorator('duration', {
                      rules: [
                        {
                          required: true,
                          message: 'Please select the recurrence interval',
                        },
                      ],
                    })(
                      <Select placeholder="Select recurrence type">
                        {DurationData.map(ele => (
                          <Select.Option key={ele.id} value={ele.id}>
                            {ele.name}
                          </Select.Option>
                        ))}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item>
                    {getFieldDecorator('recurringEmail', {
                      valuePropName: 'checked',
                      initialValue: false,
                    })(<Checkbox>Recurring</Checkbox>)}
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Body">
                <ReactQuill
                  className="mt-2 quill-editor"
                  value={emailBody}
                  onChange={setEmailBody}
                  modules={quillModules}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Live Preview">
                <iframe
                  title="Email Preview"
                  style={{
                    width: '100%',
                    height: '370px',
                    border: '1px solid #ddd',
                    display: 'block',
                  }}
                  key={emailBody} 
                  srcDoc={`<html><body>${decodeHTML(cleanExtraPTags(emailBody))}</body></html>`}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{marginTop: '10px'}}
              className="btn-success">
              {templateId ? 'Update Template' : 'Save Template'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(EmailTemplateModal)
